import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axios-dashboard';
import { baseUrlAlertas, baseUrlDashboard } from '../../assets/shared/urlApps';
import idIndicadores from "../../assets/shared/idIndicadores";
import { enqueueSnackbar } from './snackbarSlice';
import { useDispatch } from 'react-redux';

const initialState = {
  empresas: {
    loading: false,
    empresas: [],
    error: null,
    estaCargado: false
  },
  loadingCambiarEmpresa: false,
  empresasDelUsuario: {
    loading: false,
    empresas: [],
    error: null,
    estaCargado: false
  },
};

export const loadEmpresas = createAsyncThunk(
  'multiEmpresa/loadEmpresas',
  async () => {
    const response = await axios.get(`${baseUrlDashboard()}empresas/empresas`);
    return response.data;
  }
);

export const seleccionarEmpresa = createAsyncThunk(
  'multiEmpresa/seleccionarEmpresa',
  async ({ empresaId, success, errorFail }) => {
    const response = await axios.put(`${baseUrlDashboard()}empresas/CambiarEmpresaPorDefecto?empresaId=${empresaId}&indicadorId=${idIndicadores.cambiarEmpresa}`);

    response
      .then((response) => {
        if (success)
          success(response.data)
        return response.data;
      })
      .catch((error) => {
        if (errorFail)
          errorFail(error)
        return error;
      });
  }
);

export const loadEmpresasDelUsuario = createAsyncThunk(
  'multiEmpresa/loadEmpresasDelUsuario',
  async (idUsuario) => {
    const response = await axios.get(`${baseUrlAlertas()}api/usuario/${idUsuario}/empresas`);
    return response.data;
  })

export const multiEmpresaSlice = createSlice({
  name: 'multiEmpresa',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadEmpresas.pending, (state) => {
        state.empresas.loading = true;
        state.empresas.empresas = [];
        state.empresas.estaCargado = false;
        state.empresas.error = null;
      })
      .addCase(loadEmpresas.fulfilled, (state, response) => {
        state.empresas.loading = false;
        state.empresas.empresas = response.payload;
        state.empresas.estaCargado = true;
        state.empresas.error = null;
      })
      .addCase(loadEmpresas.rejected, (state, error) => {
        state.empresas.loading = false;
        state.empresas.empresas = [];
        state.empresas.estaCargado = true;
        state.empresas.error = error;
      })

      .addCase(seleccionarEmpresa.pending, (state) => {
        state.loadingCambiarEmpresa = true;
      })
      .addCase(seleccionarEmpresa.fulfilled, (state, response) => {
        const data = response.payload.data;
        sessionStorage.setItem('empresaId', data.empresaId);
        sessionStorage.setItem('monedaId', data.monedaId);
        sessionStorage.setItem('monedaSigno', data.monedaSigno);
        sessionStorage.setItem('empresaNombre', data.empresa);

        state.loadingCambiarEmpresa = false;

        if (response.payload.success);
        response.payload.success();
      })
      .addCase(seleccionarEmpresa.rejected, (state, response) => {
        const dispatch = useDispatch();
        dispatch(
          enqueueSnackbar({
            message: `No se pudo cambiar de empresa, intente nuevamente.`,
            options: {
              key: new Date().getTime() + Math.random(),
              variant: 'error'
            }
          })
        );

        state.loadingCambiarEmpresa = false;

        if (response && response.payload.errorFail);
        response.errorFail();
      })

      .addCase(loadEmpresasDelUsuario.pending, (state) => {
        state.empresasDelUsuario.loading = true;
        state.empresasDelUsuario.empresas = [];
        state.empresasDelUsuario.estaCargado = false;
        state.empresasDelUsuario.error = null;
      })
      .addCase(loadEmpresasDelUsuario.fulfilled, (state, response) => {
        state.empresasDelUsuario.loading = false;
        state.empresasDelUsuario.empresas = response.payload;
        state.empresasDelUsuario.estaCargado = true;
        state.empresasDelUsuario.error = null;
      })
      .addCase(loadEmpresasDelUsuario.rejected, (state, error) => {
        state.empresasDelUsuario.loading = false;
        state.empresasDelUsuario.empresas = [];
        state.empresasDelUsuario.estaCargado = true;
        state.empresasDelUsuario.error = error;
      })
  }
});

export default multiEmpresaSlice.reducer;